import React, { useState, useEffect } from "react";
import axios from "axios";
import "../../Styles/ViewStudentAttendance.css";
import Loader from "../../Components/Loader"; 

const months = [
    "January", "February", "March", "April", "May", "June",
    "July", "August", "September", "October", "November", "December",
];

const years = Array.from({ length: 10 }, (_, i) => new Date().getFullYear() - i);

function ViewStudentAttendance() {
    const [selectedMonth, setSelectedMonth] = useState(new Date().getMonth());
    const [selectedYear, setSelectedYear] = useState(new Date().getFullYear());
    const [attendanceData, setAttendanceData] = useState([]);
    const [error, setError] = useState(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const fetchAttendanceData = async () => {
            try {
                const token = localStorage.getItem("authToken");
                if (!token) {
                    throw new Error("Authentication token is missing");
                }

                const response = await axios.get(
                    `https://api.uniums.com/api/student/student-attendance-summary`,
                    { headers: { Authorization: `Bearer ${token}` } }
                );

                if (response.data && response.data.data) {
                    setAttendanceData(response.data.data);
                } else {
                    throw new Error("No attendance data found.");
                }
            } catch (err) {
                console.error("Frontend Error:", err.response?.data || err.message);
                setError(err.response?.data?.error || err.message);
            } finally {
                setLoading(false);
            }
        };

        fetchAttendanceData();
    }, [selectedMonth, selectedYear]);

    const getAttendanceStatus = (attendanceInfo) => {
        if (!attendanceInfo) return { text: "No Data", colorClass: "no-data" };

        const { presentSubjects, absentSubjects, statusColor } = attendanceInfo;
        if (statusColor === "Green") {
            return { text: "Present", colorClass: "present" };
        } else if (statusColor === "Orange") {
            return { text: "Partially Attended", colorClass: "partial" };
        } else if (statusColor === "Red") {
            return { text: "Absent", colorClass: "absent" };
        }
        return { text: "No Data", colorClass: "no-data" };
    };

    const daysInMonth = new Date(selectedYear, selectedMonth + 1, 0).getDate();
    const firstDayOfMonth = new Date(selectedYear, selectedMonth, 1).getDay();

    const renderCalendar = () => {
        const calendar = [];
        let currentDay = 1;

        for (let week = 0; week < 6; week++) {
            const days = [];
            for (let day = 0; day < 7; day++) {
                if (week === 0 && day < firstDayOfMonth) {
                    days.push(<td key={`empty-${day}`} className="empty-day"></td>);
                } else if (currentDay > daysInMonth) {
                    days.push(<td key={`extra-${day}`} className="empty-day"></td>);
                } else {
                    const currentDate = new Date(selectedYear, selectedMonth, currentDay).toLocaleDateString();
                    const dayAttendance = attendanceData.find(entry =>
                        new Date(entry.date).toLocaleDateString() === currentDate
                    );

                    const { text, colorClass } = getAttendanceStatus(dayAttendance);

                    days.push(
                        <td key={currentDay} className={`calendar-day ${colorClass}`}>
                            <div className="date-number">{currentDay}</div>
                            <div className="attendance-status">
                                {text}
                            </div>
                        </td>
                    );
                    currentDay++;
                }
            }
            calendar.push(<tr key={week}>{days}</tr>);
        }

        return calendar;
    };

    return (
        <div className="faculty-dashboard">
            <h1>View Student Attendance</h1>

            {loading ? (
                <Loader /> 
            ) : (
                <>
                    {error && <p className="error">{error}</p>}

                    <div className="dropdowns">
                        <select
                            value={selectedMonth}
                            onChange={(e) => setSelectedMonth(Number(e.target.value))}
                        >
                            {months.map((month, index) => (
                                <option key={index} value={index}>
                                    {month}
                                </option>
                            ))}
                        </select>

                        <select
                            value={selectedYear}
                            onChange={(e) => setSelectedYear(Number(e.target.value))}
                        >
                            {years.map((year, index) => (
                                <option key={index} value={year}>
                                    {year}
                                </option>
                            ))}
                        </select>
                    </div>

                    <table className="calendar">
                        <thead>
                            <tr>
                                <th>Sun</th>
                                <th>Mon</th>
                                <th>Tue</th>
                                <th>Wed</th>
                                <th>Thu</th>
                                <th>Fri</th>
                                <th>Sat</th>
                            </tr>
                        </thead>
                        <tbody>{renderCalendar()}</tbody>
                    </table>
                </>
            )}
        </div>
    );
}

export default ViewStudentAttendance;
